import "./LinedCard.scss"
import { Icon } from '@iconify/react';

export default function LinedCard({ icon, iconBackgroundColor, header, children }: { icon?: any; iconBackgroundColor?: string; header?: any; children?: any}) {
    return (
        <div className="lined-card-wrapper">
            <div className="lined-card-header">
                {icon ? (
                    <Icon icon={icon} style={{backgroundColor: iconBackgroundColor? iconBackgroundColor:'none'}} className="icon-arrows"/>
                ) : (
                    <h2 style={{paddingLeft:'1.5em'}} className="lined-card-title">{header}</h2>
                )}
                {header && icon && <h2 className="lined-card-title">{header}</h2>}
            </div>
            <div className="lined-card-body">{children}</div>
        </div>
    );
}